const addProductNewStyles = (theme) => ({
  container: {
    height: "100%",
    backgroundColor: "#FFFFFF",
    margin: "0 auto",
    padding: "20px"
  },
  formContainer: {
    width: { xs: "89%", sm: "95%", md: "90%", lg: "80%" },
    backgroundColor: theme?.palette?.customColor?.white || "#FFFFFF",
    py: "33px",
    px: { xs: "20px", sm: "30px", md: "40px", lg: "56px"},
    margin: "0 auto",
  },
  backBtnContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  backBtn: {
    cursor: "pointer",
  },
  title: {
    fontFamily: "Lexend",
    fontSize: "24px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  productInformationSection: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  subHeading: {
    fontFamily: "Lexend",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.primary?.main || "#0F0F0F",
    marginBottom: "10px",
  },
  textField: {
    width: "100%",
  },
  doubleTextFields: {
    display: "flex",
    gap: { xs: "10px", sm: "20px", md: "40px" },
    flexDirection: { xs: "column", sm: "column", md: "row" },
  },
  pricingQuantitySection: {
    marginTop: "20px",
  },
  productInformationDataBoxWrap: {
    marginTop: "20px",
    width: "90%",
    padding: "20px",
    borderRadius: "0px",
    backgroundColor: theme?.palette?.customColor?.secondaryFirst || "#F5F5F5",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  commonTitle2: {
    fontFamily: "Lexend",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "100%",
    color: theme?.palette?.customColor?.placeholder || "#999999",
  },
  productInformationDataTextWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  productInformationDataText: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  commonTitle3: {
    fontFamily: "Lexend",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "100%",
    color: "#0F0F0F",
  },
  priceQuantityInput: {
    maxWidth: "200px",
    "& .MuiOutlinedInput-root": {
      height: "auto",
      padding: "8px 14px",
    },
    "& input": {
      padding: 0,
      fontFamily: "Lexend",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "100%",
      color: theme?.palette?.primary?.main || "#0F0F0F",
    },
  },
  addVariantSection: {
    mt: "16px",
    width: { xs: "89%", sm: "95%", md: "90%", lg: "80%" },
    backgroundColor: theme?.palette?.customColor?.white || "#FFFFFF",
    py: "33px",
    px: { xs: "20px", sm: "30px", md: "40px", lg: "56px"},
    mx: "auto",
  },
  variantsList: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  addVariantButtonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
  },
  addVariantButton: {
    padding: "5px 15px",
    fontSize: "16px",
    textTransform: "none",
    borderRadius: "0px",
  },
  switchWrap: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  customSwitch: (isActive) => ({
    width: "40px",
    height: "15px",
    backgroundColor: isActive 
      ? (theme?.palette?.secondary?.main || "#A78D78")
      : (theme?.palette?.customColor?.secondarySecond || "#E0E0E0"),
    borderRadius: "30px !important",
    cursor: "pointer",
    position: "relative",
    transition: "0.3s ease",
    "& .MuiSwitch-track": {
      backgroundColor: "transparent !important",
    },
    "& .MuiSwitch-thumb": {
      position: "absolute",
      top: "4px",
      left: "4px",
      width: "16px",
      height: "16px",
      backgroundColor: `${theme?.palette?.customColor?.white || "#FFFFFF"} !important`,
      borderRadius: "50%",
      transition: "transform 0.3s ease",
    },
    "& .Mui-checked .MuiSwitch-thumb": {
      transform: "translateX(-3px) !important",
    },
  }),
  customSwitchText: {
    fontFamily: "Lexend",
    fontWeight: 400,
    fontSize: "12px",
    marginLeft: "10px",
    lineHeight: "15px",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
});

export default addProductNewStyles;

